<script>
import Seat from '@components/seat.vue'

export default {
  components: { Seat },
  props: {
    seatmapData: {
      type: Array,
      required: true,
    },
    showBays: {
      type: Boolean,
    },
    showAttributes: {
      type: Boolean,
    },
    scale: {
      type: Boolean,
    },
    showNoseCone: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedSeat: null,
    }
  },
  methods: {
    selectSeat(payload) {
      console.log(payload)
      this.selectedSeat = payload
    },
    getBayText(bay) {
      if (bay) {
        return `Bay ${bay}`
      }
      return ``
    },
    getBayAndClassText(bay, cabinClass) {
      if (bay) {
        return `${bay} / ${cabinClass}`
      }
      return `${cabinClass}`
    },
    getClassBlock(cabinClass) {
      if (cabinClass === 'C') {
        return `classBlockBusiness`
      } else if (cabinClass === 'F') {
        return `classBlockFirst`
      }
      return `classBlockEconomy`
    },

    getNoseConePos() {
      if (!this.seatmapData) return
      var widest = 0

      this.seatmapData.forEach((seatmapRow) => {
        if (seatmapRow.SeatMap.trim().length > widest) {
          widest = seatmapRow.SeatMap.trim().length
        }
      })
      const returnWidth = widest * 28 + 12 + 10
      if (returnWidth < 200) {
        const marginBottom = 2.51
        return `width: ${returnWidth}px; margin-bottom: -${returnWidth /
          marginBottom}px;`
      }
      if (returnWidth < 300) {
        const marginBottom = 2.88
        return `width: ${returnWidth}px; margin-bottom: -${returnWidth /
          marginBottom}px;`
      }
      if (returnWidth >= 300) {
        const marginBottom = 3.5
        return `width: ${returnWidth}px; margin-bottom: -${returnWidth /
          marginBottom}px;`
      }
    },
    getDeckWidest() {
      if (!this.seatmapData) return
      var widest = 0

      this.seatmapData.forEach((seatmapRow) => {
        console.log(seatmapRow.SeatMap)
        if (seatmapRow.SeatMap.trim().length > widest) {
          widest = seatmapRow.SeatMap.trim().length
        }
      })

      return `width: ${widest * 28 + 12 + 10}px`
    },
    getPlaneWidth() {
      if (!this.seatmapData) return
      var widest = 0

      this.seatmapData.forEach((seatmapRow) => {
        console.log(seatmapRow.SeatMap)
        if (seatmapRow.SeatMap.trim().length > widest) {
          widest = seatmapRow.SeatMap.trim().length
        }
      })

      return `width: ${widest * 28 + 12 + 100}px`
    },
    getPaxText(index, paxSeats, seatNumber, text) {
      if (paxSeats == null) {
        return `${seatNumber.toUpperCase()} ${text}`
      }
      const ps = paxSeats.find((p) => p.SeatMapIndex === index)
      if (ps !== null) {
        return `${ps.SeatNumber}\t${ps.Class}\n${ps.PaxName}\n${ps.PaxStatus}\t${ps.PaxType}\t${ps.PaxGroup}${ps.GroupSize}`
      }
      return null
    },

    showColumnLetters(row, prevRow) {
      if (!prevRow) return true
      return (
        row.Class !== prevRow.Class ||
        row.SeatMap.toUpperCase() !== prevRow.SeatMap.toUpperCase()
      )
    },
    showDeck(row, prevRow) {
      if (!prevRow) return true
      return row.Deck.toUpperCase() !== prevRow.Deck.toUpperCase()
    },
    showCabinClass(row, prevRow) {
      if (!prevRow) return true
      return row.Class.toUpperCase() !== prevRow.Class.toUpperCase()
    },
    showExitRow(exitRow, seat) {
      return exitRow === 'E' && seat.includes('X')
    },
    showDestinationBlock(row) {
      return row.Destination !== null
    },
  },
}
</script>

<template>
  <div>
    <div v-if="seatmapData" id="plane" :class="scale ? 'scale' : ''" :style="getPlaneWidth()">
      <!--  -->
      <!-- START - Show Plane Nose Cone -->
      <template v-if="showNoseCone">
        <img
          :src="require('./../../assets/svg/planehead.svg')"
          class="plane-start"
          :style="getNoseConePos()"
        />
      </template>
      <!-- END - Show Plane Nose Cone -->
      <!--  -->
      <!--  -->
      <!-- @@TODO - This should be a functional component to show deck name checking if the deck name changes!! -->
      <!-- START - Show Deck Name -->
      <div class="deckStart" :style="getDeckWidest()">
        {{ seatmapData[0] ? seatmapData[0].Deck : '' }}
        - {{ seatmapData[0] ? seatmapData[0].Class : '' }}
      </div>
      <!-- END - Show Deck Name -->
      <!--  -->
      <!--  -->
      <!-- START - First Row Column Letters -->
      <!-- <div class="seatMap row-sticky" :style="getDeckWidest()">
        <div class="columns">
          <div
            v-for="(columnLetter, col) in seatmapData[0].SeatMap.trim()"
            :key="col"
            class="columnLetter"
            >{{ columnLetter }}</div
          >
        </div>
      </div>-->
      <!-- END - First Row Column Letters -->
      <!--  -->

      <template>
        <span
          v-for="(seatmapRow, row) in seatmapData"
          :key="row"
          :data-bay="seatmapRow.Bay"
          :data-class="seatmapRow.Class"
          class="pos-r"
          :class="{'show-bays': showBays}"
        >
          <!--  -->
          <!-- START - Cabin Class -->
          <!-- <template v-if="showCabinClass(seatmapRow, seatmapData[row - 1])">
            {{ seatmapData[row].Class }}
          </template>-->
          <!-- END - Cabin Class -->
          <!--  -->
          <template v-if="showColumnLetters(seatmapRow, seatmapData[row - 1])">
            <div class="seatMap row-sticky top" :style="getDeckWidest()">
              <div class="columns">
                <div
                  v-for="(columnLetter, col) in seatmapData[row].SeatMap.trim()"
                  :key="col"
                  class="columnLetter"
                >{{ columnLetter !== '-' ? columnLetter : '' }}</div>
              </div>
            </div>
          </template>
          <template>
            <div v-if="showDeck(seatmapRow, seatmapData[row - 1])">
              <div class="nonSeatMap">
                <!-- <div class="deckFinish" :style="getDeckWidest()"></div> -->
                <!-- <div class="blankLine"></div> -->
                <!-- <div class="deckStart" :style="getDeckWidest()">{{
                  seatmapRow.Deck
                }}</div>-->
              </div>
            </div>
          </template>

          <div
            v-if="seatmapRow.ExitRow === 'E'"
            class="seatMap exit-spacer"
            :style="getDeckWidest()"
            :class="[
              seatmapRow.ExitRow === 'E' ? 'exit-row' : '',
              seatmapRow.Overwing === 'W' ? 'wing-row' : '',
            ]"
          >
            <div class="left">
              <svg
                aria-hidden="true"
                focusable="false"
                data-prefix="fas"
                data-icon="angle-double-left"
                class="svg-inline--fa fa-angle-double-left fa-w-14"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 448 512"
              >
                <path
                  fill="currentColor"
                  d="M223.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L319.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L393.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34zm-192 34l136 136c9.4 9.4 24.6 9.4 33.9 0l22.6-22.6c9.4-9.4 9.4-24.6 0-33.9L127.9 256l96.4-96.4c9.4-9.4 9.4-24.6 0-33.9L201.7 103c-9.4-9.4-24.6-9.4-33.9 0l-136 136c-9.5 9.4-9.5 24.6-.1 34z"
                />
              </svg>
            </div>
            <div class="right">
              <svg
                aria-hidden="true"
                focusable="false"
                data-prefix="fas"
                data-icon="angle-double-right"
                class="svg-inline--fa fa-angle-double-right fa-w-14"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 448 512"
              >
                <path
                  fill="currentColor"
                  d="M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34zm192-34l-136-136c-9.4-9.4-24.6-9.4-33.9 0l-22.6 22.6c-9.4 9.4-9.4 24.6 0 33.9l96.4 96.4-96.4 96.4c-9.4 9.4-9.4 24.6 0 33.9l22.6 22.6c9.4 9.4 24.6 9.4 33.9 0l136-136c9.4-9.2 9.4-24.4 0-33.8z"
                />
              </svg>
            </div>
          </div>
          <div
            class="seatMap"
            :style="getDeckWidest()"
            :class="[
              seatmapRow.ExitRow === 'E' ? 'exit-row' : '',
              seatmapRow.Overwing === 'W' ? 'wing-row' : '',
            ]"
          >
            <div
              v-for="(graphicalSeat, seat) in seatmapRow.AllocationSeatMap"
              :key="seat"
              class="seatPos"
              :class="[
                showExitRow(seatmapRow.ExitRow, graphicalSeat) ? 'is-exit' : '',
                graphicalSeat === '-' ? 'is-aisle' : '',
              ]"
            >
              <!-- Aisle -->
              <template v-if="graphicalSeat === '-'">
                <div class="aisleSeat">{{ seatmapRow.RowNumber }}</div>
              </template>

              <!-- Galley -->
              <template v-else-if="graphicalSeat === '&'"></template>

              <!-- Toilet -->
              <template v-else-if="graphicalSeat === 'T'"></template>

              <!-- No Seat -->
              <template
                v-else-if="
                  seatmapRow.SeatMap[seat] ===
                    seatmapRow.SeatMap[seat].toLowerCase()
                "
              >
                <Seat
                  class="seat no-seat"
                  :seat-row="seatmapRow.RowNumber"
                  :seat-column="seatmapRow.SeatMap[seat]"
                ></Seat>
              </template>

              <!-- Free Seat -->
              <template v-else-if="graphicalSeat === '%' || graphicalSeat === '%X'">
                <Seat
                  :seat-row="seatmapRow.RowNumber"
                  :seat-column="seatmapRow.SeatMap[seat]"
                  class="seat"
                  :show-attributes="showAttributes"
                  :seat-attributes="seatmapRow.ServicesSeatMap[seat]"
                  :selected-seat="selectedSeat"
                  @selectSeat="selectSeat"
                />
              </template>

              <!-- Boarded  -->

              <template v-else-if="graphicalSeat[0] === '*' || graphicalSeat === '*X'">
                <!-- <code>{{graphicalSeat}}</code> -->
                <Seat
                  :seat-row="seatmapRow.RowNumber"
                  :seat-column="seatmapRow.SeatMap[seat]"
                  class="seat"
                  :has-pax="graphicalSeat.split('').includes('*')"
                  pax-type="BRD"
                  :show-attributes="showAttributes"
                  :seat-attributes="seatmapRow.ServicesSeatMap[seat]"
                  :selected-seat="selectedSeat"
                  @selectSeat="selectSeat"
                />
              </template>

              <!-- Dest Block -->
              <template v-else-if="graphicalSeat === 'D' || graphicalSeat === 'DX'"></template>

              <!-- ??? -->
              <template
                v-else-if="
                  graphicalSeat[1] === 'D' ||
                    (graphicalSeat[1] === 'D' && graphicalSeat[2] === 'X')
                "
              >
                <!-- <div
                class="destinationSeat"
                :title="
                  getSeatDescription(
                    seatmapRow.RowNumber + seatmapRow.SeatMap[seat],
                    'Destination Blocked',
                  )
                "
                >{{ graphicalSeat[0] }}
                </div
                >-->
              </template>

              <template
                v-else-if="
                  graphicalSeat[0] in
                    ['1', '2', '3', '4', '5', '6', '7', '8', '9']
                "
              >
                <!-- Checked Pax -->
                <Seat
                  :seat-row="seatmapRow.RowNumber"
                  :seat-column="seatmapRow.SeatMap[seat]"
                  class="seat"
                  :has-pax="true"
                  pax-type="CKD"
                  :selected-seat="selectedSeat"
                  :show-attributes="showAttributes"
                  :seat-attributes="seatmapRow.ServicesSeatMap[seat]"
                  @selectSeat="selectSeat"
                />
              </template>

              <template v-else>
                <Seat
                  class="seat"
                  :seat-row="seatmapRow.RowNumber"
                  :seat-column="seatmapRow.SeatMap[seat]"
                  :selected-seat="selectedSeat"
                  :show-attributes="showAttributes"
                  :seat-attributes="seatmapRow.ServicesSeatMap[seat]"
                  :seat-block="
                    ['SB', 'SBX', 'HB', 'HBX', 'PX', 'P'].includes(
                      seatmapRow.AllocationSeatMap[seat],
                    )
                  "
                  :seat-block-type="seatmapRow.AllocationSeatMap[seat]"
                  @selectSeat="selectSeat"
                />
              </template>
            </div>
          </div>

          <div
            v-if="showDestinationBlock(seatmapRow)"
            class="destinationBlock"
          >{{ seatmapRow.Destination }}</div>
          <!-- <div class="seatPos bay">{{seatmapRow.Bay}}</div> -->
        </span>
      </template>
      <!-- end -->
      <div class="deckFinish" :style="getDeckWidest()"></div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
$width: 35px;
$color-grey: #d0d6dd;

.key > div {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  align-content: center;
  margin-bottom: 5px;
  > div:nth-child(2) {
    margin-left: 5px;
    font-size: 0.8rem;
    font-weight: normal;
  }
}

.plane-row {
  border-bottom: 1px solid transparent;
}

[data-bay].show-bays {
  background: #e3e7eb;
  border-bottom: 1px solid #f8f9fab8;
  transition: all 0.25s;
}

[data-bay].show-bays:after {
  content: attr(data-bay);
  position: relative;
  right: 0px;
  font-size: 0.7rem;
  font-weight: 500;
  opacity: 1;
  bottom: 0;
  padding: 0 20px;
  color: #fff;
}

.scale {
  .row-sticky {
    position: relative !important;
  }
}

div#plane {
  margin: auto;
  width: 300px;
}
.seatPos {
  position: relative;
}

// .seatPos.is-exit {
//     margin-top: 3px;
// }

.seatPos.is-exit:before {
  content: '';
  background: #4caf50;
  width: 35px;
  height: 4px;
  z-index: 99;
  position: absolute;
  left: 0;
  right: 0;
  top: -6px;
  border-radius: 10px;
}

.exit-spacer svg {
  height: 17px;
  color: white;
  vertical-align: middle;
  position: relative;
  top: -1px;
  margin: 0 5px;
}

.seatMap {
  position: relative;
}

.seatMap.wing-row:after {
  content: '';
  position: absolute;
  width: 10px;
  height: 40px;
  background: #d0d6dd;
  right: -15px;
}

.seatMap.wing-row:before {
  content: '';
  position: absolute;
  width: 10px;
  height: 40px;
  background: #d0d6dd;
  left: -15px;
}

.aisleSeat {
  line-height: 30px;
  font-size: 0.7rem;
  font-weight: 600;
}

.columns {
  width: 100%;
  text-align: center;
}

.columnLetter {
  display: inline-block;
  width: $width/1.3;
  text-transform: uppercase;
  text-align: center;

  font-size: 0.8rem;
  font-weight: 600;
  padding: 10px 0;
}

.row-sticky {
  position: sticky !important;
  top: 0 !important;
  background: white;
  z-index: 9;
  &.top {
    z-index: 92;
  }
}

.exit-spacer {
  margin-top: -3px;
  font-size: 0.7rem;
  color: white;
  font-weight: 600;
  padding: 0px;

  height: 18px;
  display: flex !important;
  justify-content: space-between !important;

  align-items: center;
  align-content: center;
  background: $color-grey !important;
}

.no-seat {
  opacity: 0;
  visibility: hidden;
}

.seatmap-content {
  margin-left: 54px;
  width: 100%;
  height: 100%;
  //   overflow: hidden;
}

.seatMap {
  display: inline-flex;
  //   background-color: lightgrey;
  justify-content: center;
  // background: #fdfdfdc9;

  border-left: 2px solid $color-grey;
  border-right: 2px solid $color-grey;
  margin-bottom: -1px;
  background: white;
}
.nonSeatMap {
  background-color: transparent;
}
.blankLine {
  display: inline-block;
  background-color: transparent;
  margin-bottom: 6px;
}
.columnLetter {
  display: inline-block;
  //   background-color: lightgrey;
  //   font-size: 160%;

  text-transform: uppercase;
  text-align: center;
  // margin-bottom: 10px;
}
.deckStart {
  height: 34px;

  text-transform: uppercase;
  text-align: center;
  font-weight: 600;
  opacity: 0.75;

  border-bottom: 0;
}
.deckFinish {
  border-radius: 0px 0px 72px 72px;
  padding: 10px;
  height: 80px;
  background: #fcfcfc;
  border: 2px solid #d0d6dd;
  border-top: 0;
  background: linear-gradient(0deg, #d0d6dd, #fcfcfc);
}
.keyHeader {
  //   font-size: 136%;
  width: 64px;
}
.key {
  display: inline-block;
  font-weight: bold;
  width: 196px;
  padding: 2px;
  text-align: left;
  margin-left: 12px;
}
.attributes {
  display: inline-block;
  //   font-size: 90%;
  margin-left: 8px;
}
.leftWing {
  border-radius: 10px 0px 0px 10px;
  background-color: lightgrey;
  display: inline-block;
  width: 34px;
  height: 28px;
  padding: 2px;
  text-align: center;
}
.rightWing {
  border-radius: 0px 10px 10px 0px;
  //   background-color: lightgrey;
  display: inline-block;
  width: 34px;
  height: 28px;
  padding: 2px;
  text-align: center;
}
.noWing {
  background-color: transparent;
  display: inline-block;
  width: 34px;
}
.exitRow {
  //   background-color: rgb(123, 113, 165);
  display: inline-block;
  width: 8px;
  height: 28px;
}
.classBlock {
  display: inline-block;
  width: 26px;
  height: 26px;
  padding: 2px;
  margin-left: 8px;
  text-align: center;
}
.classBlockFirst {
  background-color: rgb(51, 153, 51);
}
.classBlockBusiness {
  background-color: rgb(106, 106, 207);
}
.classBlockEconomy {
  background-color: rgb(241, 241, 104);
}
.destinationBlock {
  display: inline-block;
  height: 26px;
  margin-left: 8px;
  font-weight: bold;
}
.attributesHeader {
  display: inline-block;
  font-size: 76%;
  margin-left: 12px;
}
.seatPos {
  display: inline-block;
  width: $width;
  height: 40px;
  //   background-color: lightgrey;
  padding: 2px;
  text-align: center;
  font-weight: bold;
  margin-right: -4px;
  margin-left: -4px;
  &.is-exit {
    // border: 2px solid rgb(123, 113, 165);
  }
}

.right {
  right: -24px;
  position: relative;
  background: #d0d6dd;
  z-index: 99;
  border-radius: 0 4px 4px 0;
  margin-top: -2px;
}
.left {
  left: -24px;
  position: relative;
  background: #d0d6dd;
  z-index: 99;
  border-radius: 4px 0 0 4px;
  margin-top: -2px;
}

[data-bay].show-bays {
  border-bottom: 1px dashed #dadfe4;
}
[data-bay='0A'].show-bays {
  background: darken(#8bc34a, 1) !important;
}
[data-bay='0B'].show-bays {
  background: darken(#03a9f4, 1) !important;
}
[data-bay='0C'].show-bays {
  background: darken(#8bc34a, 6) !important;
}
[data-bay='0D'].show-bays {
  background: darken(#03a9f4, 6) !important;
}
[data-bay='0E'].show-bays {
  background: darken(#8bc34a, 12) !important;
}
[data-bay='0F'].show-bays {
  background: darken(#00bcd4, 12) !important;
}
[data-bay='0G'].show-bays {
  background: darken(#8bc34a, 16) !important;
}

.s {
  background: rgb(214, 139, 0);
}
.plane-start {
  margin-bottom: -76px;
}

.scale {
  transform: scale(0.85);
}

.pos-r {
  position: relative;
}

[data-class='F'] .aisleSeat {
  background: #bc0000;
  color: white;
  height: 145%;
}

[data-class='Y'] .aisleSeat {
  background: #d0d6dd;
  height: 107%;
  color: #515c72;
  z-index: 8;
}
[data-class='C'] .aisleSeat {
  background: #215ef3;
  height: 129%;
  color: white;
}
.seatPos.is-aisle {
  padding: 0;
}

.aisleSeat {
  margin: 0;
  z-index: 8;
  padding: 0;
}

.seat {
  z-index: 9;
}
</style>
